import { AppRoutes } from './AppRoutes'
import { ToastProvider } from './context/ToastContext'
import './index.css'

function App() {
  return (
    <ToastProvider>
      <AppRoutes />
    </ToastProvider>
  )
}

export default App
